import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";

const TableReport = ({ salesData, colName, data }) => {
    return (
      <Box
        sx={{
          py: "20px",
          px: { xs: "10px", sm: "50px" },
          width: "100%",
          background: "#fff",
          borderRadius: "12px",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container spacing={1}>
          <Grid
            container
            spacing={1}
            sx={{ borderBottom: "1px solid #1E1E1E", padding: "10px 0px" }}
          >
            <Grid item xs={5}>
              <Typography
                fontWeight={500}
                color="primary"
                sx={{
                  paddingLeft: "30px",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Name of Service and Product
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                fontWeight={500}
                color="primary"
                sx={{
                  textAlign: "left",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Rate Per Head / NOS
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                fontWeight={500}
                color="primary"
                sx={{
                  textAlign: "left",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                GST
              </Typography>
            </Grid>
          </Grid>

          {/* Header */}
          <Grid
            container
            mt={2}
            sx={{
              height: "50vh",
              overflow: "auto",
              marginTop: "10px",
              paddingRight: "10px",
            }}
          >
            <Grid item xs={12}>
              {/* Data Rows */}
              {data.map((item, idx) => (
                <Grid
                  container
                  key={idx}
                  elevation={2}
                  sx={{
                    borderRadius: "10px",
                    my: "5px",
                    background: "#E3E3FF",
                  }}
                >
                  <Grid item xs={5}>
                    <Box p={1}>
                      <Typography
                        fontWeight={500}
                        sx={{
                          paddingLeft: "30px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        {item.itemDescription}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box sx={{ display: "flex", textAlign: "right" }} p={1}>
                      <Typography
                        sx={{
                          display: "flex",
                          textAlign: "right",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                        fontWeight={500}
                      >
                        {item?.price} / {item?.unit}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={3}>
                    <Box p={1} sx={{ display: "flex", textAlign: "right" }}>
                      <Typography
                        fontWeight={500}
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        {(item?.gst).toFixed(2)} %
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
};

export default TableReport;